<!-- TODO (later): Remove non used variables -->
<ng-template
  #optgroupTemplate
  let-country="country"
  let-flagSize="flagSize"
  let-groupBy="groupBy"
  let-index="index"
  let-item$="item$"
  let-uppercase="uppercase">
  @let groupName = uppercase ? (item$.value[groupBy || ''] | uppercase) : item$.value[groupBy || ''];
  <div
    class="bn-select__container__dropdown__item"
    [title]="groupName">
    <span class="bn-select__container__dropdown__item__text">
      <ng-template *ngTemplateOutlet="flag; context: { country, flagSize }" />
      {{ groupName }}
    </span>
    <span class="bn-select__container__dropdown__item__icon">
      @if (item$.selected) {
        <fa-icon icon="check" />
      }
    </span>
  </div>
</ng-template>

<!-- FLAG -->
<ng-template
  #flag
  let-country="country"
  let-flagSize="flagSize">
  @if (country) {
    <bn-web-ui-flag
      class="d-inline-block"
      [country]="country"
      [showTooltip]="false"
      [size]="flagSize" />
  }
</ng-template>
